"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _Owner_1 = require("./_Owner");
var _Initiator_1 = require("./_Initiator");
exports._MultipartUpload = {
    type: "structure",
    required: [],
    members: {
        UploadId: {
            shape: {
                type: "string"
            }
        },
        Key: {
            shape: {
                type: "string",
                min: 1
            }
        },
        Initiated: {
            shape: {
                type: "timestamp"
            }
        },
        StorageClass: {
            shape: {
                type: "string"
            }
        },
        Owner: {
            shape: _Owner_1._Owner
        },
        Initiator: {
            shape: _Initiator_1._Initiator
        }
    }
};
//# sourceMappingURL=_MultipartUpload.js.map